import sortByHeader from "@projectListingSvc/functions/sortByHeader";
import applyFilters from "@projectListingSvc/functions/applyFilters";
import getCaretDirection from "@projectListingSvc/functions/getCaretDirection";

const projectListingSvc = {
  sortByHeader,
  applyFilters,
  getCaretDirection,
};

export default projectListingSvc;
